import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { RemoveProductRecipeLinkingRequestInput } from './RemoveProductRecipeLinkingRequestInput';
import { RemoveProductRecipeLinkingRequestOutput } from './RemoveProductRecipeLinkingRequestOutput';

export class RemoveProductRecipeLinkingRequestService extends HttpServiceBase {

  handle = (input: RemoveProductRecipeLinkingRequestInput): Promise<Result<RemoveProductRecipeLinkingRequestOutput> | null> => {
    const promise = this.http.post<Result<RemoveProductRecipeLinkingRequestOutput>, RemoveProductRecipeLinkingRequestInput>(
      `${this.baseUrlSislogApi}/v2/recipe-by-product/product-recipe-linking-deletion`, input);
    return promise;
  }
}